import { motion } from "framer-motion";
import { container, itemUp } from "../Utils/framerMotionVariants";
import EducationCard from "./EducationCard";
import { education } from "../data/education";

const Education: React.FC = () => {
  return (
    <section id="education" className="mt-20 scroll-mt-28">
      <motion.div
        initial="hidden"
        whileInView="show"
        viewport={{ once: true }}
        variants={container}
      >
        <motion.h2
          variants={itemUp}
          className="text-2xl font-semibold text-cyan-700"
        >
          Education
        </motion.h2>
        <div className="mt-6 space-y-4">
          {education.map((edu, i) => (
            <EducationCard education={edu} />
          ))}
        </div>
      </motion.div>
    </section>
  );
};

export default Education;
